<template>
  <main-map :all-routes="listRoute" :all-routes-from-api="info" :route-colors="colorRoute" :selected-route-ids="ticked"
    :stop-painting="stopPainting" @route-selected="handleRouteSelected" @route-deselected="handleRouteDeselected">
  </main-map>

  <route-navigator :tree-data="simple" :selected-routes="ticked" :route-colors="colorRoute" :all-routes-from-api="info"
    @route-selected="handleRouteSelected" @route-deselected="handleRouteDeselected"
    @stop-painting="handleStopPainting" />
</template>

<script setup>
import {
  defineAsyncComponent, isProxy, onBeforeMount, onMounted, ref, toRaw, watch,
} from 'vue';
import preloadImages from '@/components/preload-image';
import RouteNavigator from '@/components/RouteNavigator.vue';

const MainMap = defineAsyncComponent(() => import('@/components/MainMap.vue'));

const info = ref([]);
const ticked = ref([]);
const simple = ref([]);
const listRoute = ref([]);
const colorRoute = ref({});

const stopPainting = ref(false);

const generateRandomColor = () => `#${Math.floor(Math.random() * 16777215).toString(16)}`;

onBeforeMount(() => {
  preloadImages();
});

const groupByAddressAndShift = (data) => {
  const groupedAddresses = {
    ENTRADAS: [],
    SALIDAS: [],
  };

  // Group by address
  groupedAddresses.ENTRADAS = data.filter((route) => route.direccion_ruta === 'ENTRADA');
  groupedAddresses.SALIDAS = data.filter((route) => route.direccion_ruta === 'SALIDA');

  const groupByShift = (routes) => {
    const grouped = {};

    routes.forEach((route) => {
      if (!grouped[route.turno_ruta]) {
        grouped[route.turno_ruta] = [];
      }
      grouped[route.turno_ruta].push(route);
    });

    return Object.entries(grouped).map(([shift, routes]) => ({
      key: `Turno: ${shift}`,
      children: routes.map((route) => ({ key: route.clave_ruta, name: route.nombre_ruta })),
    }));
  };

  // Transform into the required structure
  return [
    {
      key: 'Rutas: Alpezzi Robles',
      children: [
        {
          key: 'Entradas',
          children: groupByShift(groupedAddresses.ENTRADAS),
        },
        {
          key: 'Salidas',
          children: groupByShift(groupedAddresses.SALIDAS),
        },
      ],
    },
  ];
};

onMounted(async () => {
  try {
    const response = await fetch('https://rutasbusmen.geovoy.com/api/v1/rutasParadas', {
      method: 'POST',
      body: new URLSearchParams('grupo=Alpezzi Robles'),
    });

    if (response.ok) {
      const result = await response.json();
      info.value = result;
      simple.value = groupByAddressAndShift(result);
      console.log('Rutas cargadas:', result.length);
    }
  } catch (e) {
    console.error(e);
  }
});

const doesObjectExist = (id) => (colorRoute.value[id] === undefined);

const handleRouteSelected = (routeId) => {
  if (!ticked.value.includes(routeId)) {
    ticked.value.push(routeId);
  }
  stopPainting.value = false;
};

const handleRouteDeselected = (routeId) => {
  const index = ticked.value.indexOf(routeId);
  if (index !== -1) {
    ticked.value.splice(index, 1);
  }
  stopPainting.value = false;
};

const handleStopPainting = () => {
  stopPainting.value = true;
  setTimeout(() => {
    stopPainting.value = false;
  }, 2000);
};

watch(ticked, (data) => {
  const convertToArray = Object.values(data);
  let list;
  if (isProxy(info.value)) list = toRaw(info.value);
  else list = info.value;

  listRoute.value = list.filter((route) => (
    [route.clave_ruta].some((item) => convertToArray.includes(item))
  ));

  if (convertToArray.length > Object.keys(colorRoute.value).length) {
    convertToArray.forEach((id) => {
      if (doesObjectExist(id)) colorRoute.value[id] = generateRandomColor();
    });
  } else {
    Object.keys(colorRoute.value).forEach((key) => {
      const index = convertToArray.findIndex((item) => item === key);
      if (index === -1) delete colorRoute.value[key];
    });
  }
}, { deep: true });

</script>
<style scoped></style>
